function Avatar({
  name,
  status,
  isDark,
  profileImage,
}: {
  name: string
  status?: string
  isDark?: boolean
  profileImage?: string
}) {
  return (
    <>
      {profileImage !== '' ? (
        <div
          className='position-relative border rounded-circle overflow-hidden'
          style={{ width: '40px', height: '40px' }}
        >
          <img
            src={profileImage || ''}
            alt='Profile'
            className='w-100 h-100'
            style={{ objectFit: 'contain' }}
          />
        </div>
      ) : (
        <div
          className={`d-flex align-items-center justify-content-center btn btn-sm h-35px w-35px rounded-circle
       ${isDark ? 'bg-gray-100 text-gray-700' : 'bg-profile-icon text-white'}
      `}
        >
          <p className='fw-bold fs-1 mb-0'>{name.charAt(0).toUpperCase()}</p>
        </div>
      )}
    </>
  )
}
export default Avatar
